// Module
var code = `<div class="animated {{ onboardingAnimatedHeader.animationName }}" ng-if="onboardingAnimatedHeader.isActive"><div class="animated_img animated_img__{{ image }}" id="{{ image }}" ng-repeat="image in ::onboardingAnimatedHeader.images track by \$index"></div></div>`;
// Exports
export default code;